export default function PrivacyPolicy() {
  return (
    <section id="section-content" aria-label="section">
      <div className="container">
        <div className="row gx-5">
          <div className="col-lg-12 col-md-12 col-sm-12">
            <div className="d-content" style={{ marginTop: "160px" }}>
              <h1>Privacy Policy</h1>
              <h3>1. Import</h3>
              <p>
                This Privacy Policy (hereafter “Privacy Policy”) forms an
                integral part of the Terms of Use of the mteverestlimo.com
                Website (hereinafter referred to as the “Website”).
              </p>

              <p>
                The Privacy Policy covers all personal data of visitors / users
                / members collected by mteverestlimo.com during the visit and
                use of its services. Also, the Privacy Policy covers the
                conditions for collecting, processing and managing the personal
                data of visitors / users / members from mteverestlimo.com. If a
                visitor does not agree with these terms, he / she must not
                proceed with the registration process and create an account on
                the Site or follow the Exception Procedure as described below.
              </p>

              <p>
                This Privacy Policy does not cover in any way the relationship
                between visitors / users / members of the Site and any services
                not subject to control and / or ownership of mteverestlimo.com.
              </p>

              <h3>2. WAY TO THE WEB SITE</h3>

              <p>
                Every visitor can browse the site without giving any personal
                information. Personal data such as name, e-mail, date of birth
                etc. will only be needed if the visitor wishes to be a member of
                the Web site in order to be able to use its services.
                mteverestlimo.com has the ability and reserves the right to
                store the IP address of the visitor and, if necessary, to
                contact its Internet Service Provider (ISP) in the event of a
                violation of the Terms of Use of the Website / Application.
              </p>

              <h3>3. PERSONAL DATA & USER IDENTIFICATION INFORMATION (PII)</h3>
              <br />

              <h4>3.1 DATA AND INFORMATION COLLECTED</h4>
              <ul>
                <li>
                  For the use of our services, collection of certain personal
                  data or user identification information (PII) is required.
                  Personal data includes data or information that identifies a
                  person’s identity, such as name, e-mail address or other data
                  that can reasonably be associated with a person’s identity,
                  such as a mobile phone number. These data can be used to
                  identify a user in a unique way, among others, in order to
                  display targeted ads, messages, or content.
                </li>
                <li>
                  Data not necessarily associated with the identity of a natural
                  person may also be collected, including, but not limited to,
                  IP addresses, browsers, operating system, cookies, advertising
                  IDs, device type, etc.
                </li>
                <li>
                  The process of registering on the Site and using our services
                  requires the provision of a minimum amount of personal data as
                  described in Section 5.
                </li>
                <li>
                  The Site collects the information you provide when downloading
                  and using it. Registration at mteverestlimo.com is optional.
                  However, some features or services that may be offered may not
                  be available to unregistered users.
                </li>
                <li>
                  In addition, the Site may collect certain information
                  automatically, including, but not limited to, mobile device
                  type, unique device ID, mobile device IP address, operating
                  system, browsers, and information about the way the Website is
                  used.
                </li>
                <li>
                  When you use the Website, it is possible to determine your
                  current location using GPS (or similar) technology to identify
                  your area to display related messages / data / custom
                  features.
                </li>
              </ul>

              <h4>3.2 PURPOSE OF COLLECTING PERSONAL DATA</h4>

              <p>
                The personal data stated by the user / member anywhere on the
                Website are intended solely to ensure the operation of the
                services provided and the legality of the transactions concerned
                and may not be used by any third party without complying with
                the provisions of Law 2472/97 , Data Protection Directive (95/46
                / EC), ePrivacy Directive (2002/58 / EC, Amendments 2009/136 /
                EC) and Regulation (EC) 2016/679, character. Finally, using the
                services of the Site, other information may be requested or
                collected for statistical purposes, which are however
                disconnected from the user’s / member’s personal data in
                accordance with the legislation on the protection of personal
                data.
              </p>

              <h4>3.3 EXCLUSION PROCEDURE</h4>
              <ul>
                <li>
                  The user may request exclusion from the data collection and /
                  or delete the data collected so far by sending an email to our
                  email address.
                </li>
                <li>
                  Exclude your Google Cookies data collection by modifying your
                  personal settings in Google’s Ads Settings.
                </li>
                <li>
                  Exclude from collecting data from third party cookies through
                  the Network Advertising Initiative .
                </li>
                <li>
                  If you do not wish to record your location, please disable
                  Location Services in your mobile device settings.
                </li>
                <li>
                  COLLECTION AND TRANSFER OF PERSONAL DATA UNDER CONDITIONS
                </li>
              </ul>

              <p>
                mteverestlimo.com may collect and / or transfer, in accordance
                with applicable legal provisions, your personal data to third
                parties, other than restaurants, in one of the following cases:
              </p>

              <h4>4.1 Advertising, Statistics, Repetitive Marketing</h4>
              <p>
                We may be working with web / mobile app statistics to help us
                understand that the Website is also used to record statistics
                such as visit rate and length of stay on the site. We work with
                advertisers and third-party ad networks, who need to know how
                users interact with the Website. Advertisers and ad networks use
                some of the information gathered from the Site, including, but
                not limited to, the unique identifier of the user’s device and /
                or the mobile phone number. To protect the anonymity of
                information, we use encryption technology to ensure that third
                parties can not cross the identity of individuals. Partners may
                also collect anonymous information about other websites / apps
                you’ve used / downloaded, webpages you visit, exact location
                information, other inaccurate location information to display
                targeted ads within the Site, and elsewhere. Encrypted
                information you give may be passed on to our partners and
                combined with other available information about you for
                statistical analysis or advertising purposes. Our partners have
                no independent use of the information we pass on to them and
                have agreed to abide by the rules set forth in the relevant
                legislation.
              </p>
              <p>
                Users wishing to be excluded should follow the procedures
                described in section 3.3 EXCLUSION PROCEDURE
              </p>

              <h4>4.2 PARTNERSHIP WITH THIRD PARTIES</h4>
              <p>
                We may transfer data to third parties for the purpose of
                providing a service you have requested or a promotional offer
                offered by us or third parties. The transfer of information
                between affiliates includes applications or websites that
                integrate API or otherwise our services and APIs or services
                with which mteverestlimo.com is linked.
              </p>

              <h4>4.3 SOCIAL NETWORK NETWORKS</h4>
              <p>
                It is possible that within our Website we offer the possibility
                of sharing in Social Networks and other related tools that allow
                you to share your actions within the Website with other
                applications, websites or mass media, and vice versa. Using such
                features allows you to share information with your friends or
                the general public, depending on the settings you have defined
                in your personal profile. Please refer to the privacy policies
                of these social networking services for more information on how
                your data is handled.
              </p>

              <h4>4.4 NOTICE / MESSAGES IN MOBILE APPLIANCES</h4>
              <p>
                We may partner with mobile SDK partners, including the OneSignal
                Messaging SDK, for passive information collection, which
                generally helps us to send personalized alerts / messages. These
                data can also be used to identify you in a unique way, among
                other things, to display targeted ads, messages, or content.
                Depending on the permissions granted in this application (see
                section 7), this information may include personal information
                including your e-mail address. This information can also include
                exact WiFi location or information, installed and enabled
                applications, and unique device / user IDs (e.g., Android
                Advertising ID).
              </p>
              <p>Exception procedure:</p>
              <ul>
                <li>
                  Opt out of OneSignal Push Notifications Notifications You can
                  in most cases opt out of receiving notifications by going to
                  “Settings” on your device and locating the corresponding
                  settings (may be under “Notifications”), and then changing
                  these settings for some or all of your apps on your device.
                  (Different device configurations, or updates to devices, may
                  affect or change how these settings work.)
                </li>
                <li>
                  Excluding Mobile-Based Mobile Ads You can opt out of targeted
                  ads that use unique mobile IDs to serve ads based on the
                  interests of the user. Exclude these ads by opening the Google
                  Settings app on your device by selecting ‘Ads’, then choosing
                  the option to opt out of ‘Interest-Based Ads’. (Different
                  device configurations, or updates to devices, may affect or
                  change how these settings work.)
                </li>
              </ul>

              <h4>4.5 SALE / MERGER / CHANGE CONTROL</h4>
              <p>
                If there is a sale, merger, consolidation, change of control,
                transfer of essential assets, reorganization or liquidation of
                mteverestlimo.com then, at its sole discretion,
                mteverestlimo.com may transfer, sell or assign information
                gathered from the Website, to one or more related third parties.
                In this case, mteverestlimo.com will notify all members of the
                Site affected before the transfer of personal information or
                before being subject to a different privacy policy.
              </p>

              <h4>4.6 REQUEST BY JUDICIAL / POLICE / GOVERNMENT AUTHORITIES</h4>
              <p>
                mteverestlimo.com may provide data to the appropriate judicial,
                police and other administrative authorities upon legal request
                in order to:
              </p>
              <ul>
                <li>Comply with applicable laws</li>
                <li>
                  Respond to government inquiries (or inquiries from legal,
                  governmental or semi-governmental or local or Internet
                  Protection Authority of any kind)
                </li>
                <li>Comply with a valid legal process</li>
                <li>
                  Protect its rights and property, the Site and / or other users
                  of the Site
                </li>
              </ul>

              <p>
                The user / member has, within the confidentiality laws of
                telecommunications, the rights to information and objection
                provided for in Articles 11 to 13 of Law 2472/1997 and
                Regulation (EC) 2016/679, on personal data.
              </p>

              <h3>
                5. PROCEDURES REQUIRING COLLECTION AND PROCESSING OF PERSONAL
                DATA AND PUBLIC IDENTIFICATION INFORMATION (PII)
              </h3>

              <h4>5.1 Register to the Website</h4>
              <p>
                In order to create an account on the Website, the visitor must
                state his / her surname, an email and a password. During the
                sign-up process, the visitor is asked to provide additional
                optional information if so desired, such as residence area, date
                of birth, gender, contact telephone, etc. After registration,
                the above account details can be viewed / modified at any time
                and free of charge by the user / user himself using his personal
                password or by contacting mteverestlimo.com.
              </p>
              <br />

              <h4>
                5.2 Electronic Reservations / Transfer of Personal Data to
                Affiliates
              </h4>

              <p>
                In order to process an online reservation to an affiliate, the
                user / member of the Site is required to state the name of the
                reservation holder and a contact telephone number, such as
                making a phone reservation. Such data may be of the user /
                member itself or of any other natural person on whose behalf the
                user / member makes the reservation. Also, the user / member may
                optionally declare additional comments regarding the service he
                / she is about to receive. Upon completion of booking on the
                Website, the recipient’s name, contact number and any specific
                comments are automatically transferred to and in the custody
                business as they are indispensable for the best provision of the
                related services. Affiliates are legally bound to
                mteverestlimo.com to handle such information as confidential and
                to use them for the sole purpose of supporting and executing
                online reservations. These data are also kept in the archive of
                mteverestlimo.com.
              </p>
              <br />

              <h4>5.3 Comments and Reviews</h4>
              <p>
                Users who have received the services of the Site have the right
                to submit comments, reviews and ratings through their account
                based on the Terms of Use of the Website. This User Material may
                be (a) posted on the Site, (b) used and placed (in whole or in
                part) by mteverestlimo.com on social media platforms,
                newsletters, special promotional platforms, applications and
                other networks owned, hosted, used or controlled by
                mteverestlimo.com. In any case, such material will not include
                any personal data of the user while the user himself will be
                associated only with his or her first name and the first letter
                of his adjective in order to ensure his anonymity. In the event
                that a user does not wish to publish or reproduce such material,
                he should not use the particular service.
              </p>
              <br />

              <h4>5.4 Votes</h4>
              <p>
                In the context of the provision of its services or other
                promotional activities, mteverestlimo.com may invite its members
                to participate in electronic voting at regular intervals. In
                order to participate in these votes, the users / members of the
                Website should indicate the name and any other personal
                information, such as property, age, etc. (depending on the
                nature of the questions put to the vote). The user / member’s
                vote is solely for the purpose of drawing conclusions in
                relation to public opinion on a particular matter and can not be
                used for any other purpose or disclosed to third parties.
              </p>
              <br />

              <h4>5.5 Interconnection with Third Party Websites</h4>
              <p>
                Through the Site / Application, the visitor / user / member can
                access other third party websites such as social networking
                sites like facebook and twitter. In any case where the visitor /
                user / user makes use of this service, information is exchanged
                with these websites and the information that is shared will be
                governed by their respective privacy policies. The visitor /
                user / member is requested to modify the account’s privacy
                settings on these websites directly. mteverestlimo.com does not
                control the privacy policies of these third parties and assumes
                no responsibility or liability for the actions of these third
                parties.
              </p>

              <h3>6. COOKIES</h3>
              <p>
                The Site may use cookies to improve the user experience while
                browsing and to improve the overall quality of its services.
                Cookies are small text files that are sent to a user’s computer
                when they visit a site. Cookies are stored on the visitor /
                user’s hard disk, but they do not know any document or file from
                their computer. They are used to facilitate visitor / user
                access to specific mteverestlimo.com services for statistical
                purposes in order to determine the areas in which these services
                are useful or popular or for marketing purposes. The visitor /
                user / member of the Site may configure his / her browser in
                such a way as to prohibit the reception of all cookies or to
                notify him / her when sending a cookie. However, a visitor /
                user / member of the Site should be aware that certain features
                or services of the Site may not function properly without
                cookies.
              </p>

              <h3>7. IMPORTANT NOTICE FOR OPERATING SYSTEM LICENSES</h3>
              <p>
                Most mobile platforms (iOS, Android, etc.) have defined specific
                types of device data that apps can not access without your
                consent. These platforms have licensing systems to obtain your
                consent. The iOS platform will notify you the first time our
                site needs access to certain types of data and will give you the
                option to consent (or not) to this request. Android devices
                update the rights that our site requires before you use it for
                the first time while using the application is your consent. The
                rights / permissions that our website requires may change over
                time.
              </p>

              <h3>8. IP ADDRESSES</h3>
              <p>
                Each computer connected to the Internet assigns a unique number
                known as the Internet Protocol (IP) address. The IP address
                through which the visitor / user / computer’s computer has
                access to the Internet and then to the Website is stored and can
                be used by mteverestlimo.com, if necessary, in case of violation
                of the Terms Use of the Website / Application by the visitor /
                user / member.
              </p>

              <h3>9. GENERAL TERMS OF PROTECTION OF PERSONAL DATA</h3>
              <p>
                The user / member may contact mteverestlimo.com at any time and
                free of charge in order to cross-check the existence of the
                account staff, correct it, change it or delete it, and exclude
                it from receiving electronic newsletters. Upon updating personal
                information, mteverestlimo.com may ask the user / member to
                verify his / her identity before he / she can satisfy his or her
                request. Visitors / users of the Site who are minors do not have
                the right to register as members and therefore do not have an
                obligation to submit their personal information. The Account
                Holder on the Website (Member) is fully responsible for any use
                and preservation of the privacy and security of his / her
                password and must immediately notify mteverestlimo.com of any
                use of his account by a third party unauthorized and any other
                violation of his / account. mteverestlimo.com operates in
                accordance with applicable Greek and Community law and has
                adopted procedures that protect the personal data that the user
                / member provides through the Site for as long as he / she is
                registered with his / her services. Only authorized employees
                have access to them whenever necessary. These items are deleted
                after any termination of the transaction.
              </p>

              <h3>10.AMENDMENTS TO THE PRESENT POLICY</h3>
              <p>
                mteverestlimo.com reserves the right to change or modify the
                Privacy Policy at any time without notice from users / members.
                Such changes, modifications, additions or deletions to the
                Privacy Policy will enter into force immediately, that is, by
                posting them on the Site. Any use of the Site after such change
                or modification will be deemed to constitute acceptance by the
                user / member of the changes, modifications, additions or
                deletions.
              </p>
              <p>Date of latest revision: 18/05/2018</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
